import DeploymentStatus from './DeploymentStatus.container'

export default DeploymentStatus
